import React,{useEffect,useState} from 'react';
import {connect} from 'react-redux';
import {currentRouteSet} from '../../actions/actions';
import {pathSpliter} from '../../lib/functions';
import SalesVoucher from './voucher/load_salary_voucher';
import axios from 'axios';
import { APP_URL, API_URL } from "../../config.js";
const SalesVoucherQuick = ({location,currentRouteSet,authInfo})=>{
  let [institution,institutionSet] = useState(null);

    useEffect(()=>{
        currentRouteSet(pathSpliter(location.pathname,1));
        getInstitution();

    },[]);

    let getInstitution = async ()=>{
      await  axios.get(`${API_URL}/api/get-institution`,{headers:{'auth-token':authInfo.token}}).then(res=>{
          institutionSet(res.data)
   })
  }

      return(
          <>
              <SalesVoucher employeeId={parseFloat(pathSpliter(location.pathname,3))} 
               month={pathSpliter(location.pathname,4)}
               year={parseFloat(pathSpliter(location.pathname,5))}
               institution={institution} />
          </>
      )
}
  const mapStateToPops = (state)=>{
    return {
      currentRoute:state.currentRouteReducer,
      authInfo:state.authInfoReducer
    }
}

export default connect(mapStateToPops,{currentRouteSet})(SalesVoucherQuick);
